var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndPositionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u5408\\u4F53 13",
    fill: "#3086ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.996 47h-8.282A10.93 10.93 0 0121.39 45l-.129-.09-.15-.047a11.068 11.068 0 01-3.83-2.107L4.944 32.437A10.971 10.971 0 011 24.002c0-3.267 1.437-6.343 3.943-8.439l12.339-10.32a11.07 11.07 0 013.829-2.106l.15-.047.129-.09A10.93 10.93 0 0127.714 1h8.282c2.939 0 5.7 1.144 7.778 3.222A10.928 10.928 0 0146.996 12v24c0 2.938-1.144 5.7-3.222 7.778A10.928 10.928 0 0135.996 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.996 46c5.514 0 10-4.486 10-10V12c0-5.514-4.486-10-10-10h-8.282a9.936 9.936 0 00-5.749 1.816l-.257.182-.3.093a10.076 10.076 0 00-3.485 1.919L5.585 16.33A9.975 9.975 0 002 24a9.974 9.974 0 003.585 7.67l12.338 10.32a10.073 10.073 0 003.484 1.919l.301.093.258.182A9.935 9.935 0 0027.714 46h8.282m0 2h-8.282c-2.568 0-4.948-.807-6.9-2.18a12.065 12.065 0 01-4.174-2.296L4.302 33.204c-5.736-4.795-5.736-13.612 0-18.409L16.64 4.475a12.071 12.071 0 014.174-2.294A11.948 11.948 0 0127.714 0h8.282c6.628 0 12 5.372 12 12v24c0 6.628-5.372 12-12 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndPositionButton);
export default __webpack_public_path__ + "static/media/endPositionButton.ff07e209be6b8790.svg";
export { ForwardRef as ReactComponent };